import ModalSection from "@hl/base-components/lib/modal/ModalSection";
import { STATUS_COLOR } from "@hl/base-components/lib/theme/colors";
import { Button, Modal, Stack, Text, TextInput } from "@mantine/core";

import { _CollectionType } from "../../../../../../apollo/graphql.generated";

import useCollectDutchAuctionFunds from "./useCollectDutchAuctionFunds";

export const CollectDutchAuctionFundsModal = ({
  collection,
  vectorId,
  paymentRecipient,
  fundsToClaim,
  isOpened,
  onClose,
}: {
  collection: {
    id: string;
    collectionType: _CollectionType;
    editionId?: number | null;
  };
  vectorId: string;
  paymentRecipient: string;
  fundsToClaim: string;
  isOpened: boolean;
  onClose: () => void;
}) => {
  const { startClaim, buttonLabel, buttonDisabled, error } =
    useCollectDutchAuctionFunds({
      mintVectorId: vectorId,
      collectionType: collection.collectionType,
      collectionId: collection.id,
      onFinish: onClose,
    });

  return (
    <Modal opened={isOpened} onClose={onClose} size="lg" title="Withdraw funds">
      <Stack spacing={"xl"}>
        <Text>
          You are about to withdraw the available funds from your Dutch auction.
          If the auction has not ended yet, any funds from additional mints will
          automatically{" "}
          <Text span inherit fw={500}>
            be transferred to the address below.
          </Text>
        </Text>

        <Stack>
          <TextInput value={fundsToClaim} readOnly label="Amount" />
          <TextInput value={paymentRecipient} readOnly label="Receipient" />
        </Stack>
      </Stack>
      <ModalSection>
        <Button
          fullWidth
          size="lg"
          type="submit"
          disabled={buttonDisabled}
          onClick={startClaim}
        >
          {buttonLabel || "Withdraw"}
        </Button>
        {error && (
          <Text align="center" mt="xs" size="xs" color={STATUS_COLOR.ERROR}>
            {error}
          </Text>
        )}
        <Text size="xs" align="center" mt={8}>
          This action requires a transaction
        </Text>
      </ModalSection>
    </Modal>
  );
};
